import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';
import {PayvendService} from '../services/payvend.service';
import {NgxSpinnerService} from 'ngx-spinner';
import { FirmService } from '../services/firm.service';
import { Firms } from '../models/firms';

@Component({
    selector: 'app-firm-payvend',
    templateUrl: './firm-payvend.component.html',
    styleUrls: ['./firm-payvend.component.css']
})
export class FirmPayvendComponent implements OnInit {
    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    private firmId: string;
    public payvends = [];
    public payvendsFirstDeactive = [];
    public payvendsSecondsActive = [];
    public selectedId;
    public firm: any;
    public searchText;
    public selectedPayvend = {firm: new Firms(), _id: '', name: '', serial: '', status: '0'};
    flag: string = '';
    loading = false;
    firms = [];
    firmDetail = [];
    constructor(private payvendService: PayvendService,
                private router: Router,
                private route: ActivatedRoute,
                private firmService: FirmService,
                private spinner: NgxSpinnerService) {
    }

    ngOnInit() {
        this.spinner.show();
        this.firm = localStorage.getItem('firm');
        this.firmId = localStorage.getItem('firmId');
        this.flag = this.route.snapshot.paramMap.get('flag');
        if(this.flag === 'varliklar') {
            this.getvPosesForSuperAdmin();
        } else {
            this.getPayvendsByFirm(this.firmId);
        }
        this.getAllFirms();
    }

    getPayvendsByFirm(firmId: string) {
        this.spinner.show();
            this.payvendService.getPayvendsByFirm(firmId).subscribe(res => {
                this.payvends = [];
                this.payvendsFirstDeactive = [];
                this.payvendsSecondsActive = [];
                res.dataVPos.forEach(data => {
                    if (!data.status) {
                        this.payvendsFirstDeactive.push(data);
                    } else {
                        this.payvendsSecondsActive.push(data);
                    }
                });
                this.payvends = this.payvendsFirstDeactive.concat(this.payvendsSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
    }

    createPayvend(name, serial, status) {
        if (name === '' || name === undefined || serial === '' || serial === undefined || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const Payvend = {name: name, serial: serial, firm: this.firmId, status: status};
        this.payvendService.createPayvend(Payvend).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeCreateModal.nativeElement.click();
            if(this.flag === 'varliklar') {
                this.getvPosesForSuperAdmin();
            } else {
                this.getPayvendsByFirm(this.firmId);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    updatePayvend(name, serial, status) {
        if (name === '' || name === undefined || serial === '' || serial === undefined || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const Payvend = {name: name, serial: serial, firm: this.firmId, status: status};
        this.payvendService.updatePayvend(Payvend, this.selectedId).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeUpdateModal.nativeElement.click();

            if(this.flag === 'varliklar') {
                this.getvPosesForSuperAdmin();
            } else {
                this.getPayvendsByFirm(this.firmId);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getPayvendById(id) {
        this.spinner.show();
        this.payvendService.getPayvendById(id).subscribe(res => {
            if (res.success) {                
                this.selectedPayvend = res.vpos;
                this.spinner.hide();
            } else {
                this.errorSwal.title = 'Hata!';
                this.errorSwal.text = res.message;
                this.errorSwal.show();
                this.spinner.hide();
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    selected(id) {
        this.selectedId = id;
        this.getPayvendById(id);
    }

    deletePayvend(id) {
        if (id === '' || id === undefined) {
            this.errorSwal.title = 'Payvend id alınamadı!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        this.payvendService.deletePayvend(id).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            if(this.flag === 'varliklar') {
                this.getvPosesForSuperAdmin();
            } else {
                this.getPayvendsByFirm(id);
            }
            this.spinner.hide();
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getAllFirms() {
        this.firmService.getAllFirms().subscribe(res => {
            if (res.success) {
                this.firms = res.firms;
                for (const firm of this.firms) {
                    this.firmDetail.push(firm._id);
                }
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }

    getvPosesForSuperAdmin() {
        this.spinner.show();
        this.flag = this.route.snapshot.paramMap.get('flag');
        if(this.flag === 'varliklar') {
            this.payvendService.getvPosesForSuperAdmin().subscribe(res => {
                this.payvends = [];
                this.payvendsFirstDeactive = [];
                this.payvendsSecondsActive = [];
                res.forEach(data => {
                    if (!data.status) {
                        this.payvendsFirstDeactive.push(data);
                    } else {
                        this.payvendsSecondsActive.push(data);
                    }
                });
                this.payvends = this.payvendsFirstDeactive.concat(this.payvendsSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
        }
    }

    onSelectPayvendCreate() {
        this.firmId = this.selectedPayvend.firm._id;
    }
    onSelectPayvendUpdate() {
        this.firmId = this.selectedPayvend.firm._id;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-payvend/firm-payvend.component.ts